import { createStore } from "owa-satcheljs";
import { getAccountKeyForMailboxInfo, type MailboxInfo } from "owa-client-types";
import type InboxViewType from "owa-service/lib/contract/InboxViewType";
import type FocusedInboxRollupStore from "./schema/FocusedInboxRollupStore";

function getDefaultStore() {
    return {
        uniqueSenders: undefined,
        unseenCountToDisplay: undefined,
        viewType: 0,
    };
}

const mailboxInfoToStoreMap = new Map<string, FocusedInboxRollupStore>();

export const getStore = (mailboxInfo: MailboxInfo): FocusedInboxRollupStore => {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const key = accountKey + "_focusedInboxRollupStore";
    
    let cachedStore = mailboxInfoToStoreMap.get(key);
    if (!cachedStore) {
        /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
         *	> Function should only be invoked in module scope */
        const store = createStore<FocusedInboxRollupStore>(key, getDefaultStore())();
        mailboxInfoToStoreMap.set(key, store);
        cachedStore = store;
    }
    
    return cachedStore;
};
